import script from "./ResourcesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcesTable.vue?vue&type=script&setup=true&lang=js"

import "./ResourcesTable.vue?vue&type=style&index=0&id=385cc168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385cc168"]])

export default __exports__